import Menu from "./modules/menu";
import Theme from "./modules/theme";
import AssemblyDocumentation from "./modules/accordion";
import HeaderScroll from "./modules/scroll";

Menu.init();
Theme.init();
AssemblyDocumentation.init();
HeaderScroll.init();